'use client';

import { useEffect } from 'react';

export default function FaqSectionClient() {
  useEffect(() => {
    const handleToggle = (e: Event) => {
      const target = e.target as HTMLElement;
      const questionButton = target.closest('[data-faq-question]') as HTMLElement;
      
      if (!questionButton) return;
      
      const faqId = questionButton.getAttribute('data-faq-question');
      if (!faqId) return;
      
      const answerElement = document.querySelector(`[data-faq-answer="${faqId}"]`) as HTMLElement;
      const itemElement = document.querySelector(`[data-faq-item="${faqId}"]`) as HTMLElement;
      const answerBorder = answerElement?.querySelector('.faq-answer-border') as HTMLElement;
      
      if (!answerElement || !itemElement) return;
      
      const isOpen = questionButton.getAttribute('aria-expanded') === 'true';
      const willBeOpen = !isOpen;
      
      // Toggle aria-expanded
      questionButton.setAttribute('aria-expanded', willBeOpen.toString());
      
      // Toggle answer visibility
      if (isOpen) {
        answerElement.classList.remove('max-h-[2000px]', 'opacity-100');
        answerElement.classList.add('max-h-0', 'opacity-0');
      } else {
        answerElement.classList.remove('max-h-0', 'opacity-0');
        answerElement.classList.add('max-h-[2000px]', 'opacity-100');
      }
      
      // Toggle question button background
      if (willBeOpen) {
        questionButton.classList.add('bg-white/10', 'rounded-t');
        questionButton.classList.remove('hover:bg-white/5');
      } else {
        questionButton.classList.remove('bg-white/10', 'rounded-t');
        questionButton.classList.add('hover:bg-white/5');
      }
      
      // Toggle border positioning
      // When open: hide border on item, show border on answer
      // When closed: show border on item, hide border on answer
      if (willBeOpen) {
        itemElement.classList.remove('border-b');
        if (answerBorder) {
          answerBorder.classList.remove('hidden');
        }
      } else {
        itemElement.classList.add('border-b');
        if (answerBorder) {
          answerBorder.classList.add('hidden');
        }
      }
      
      // Toggle arrow rotation
      const arrow = questionButton.querySelector('svg');
      if (arrow) {
        if (willBeOpen) {
          arrow.classList.add('rotate-180');
        } else {
          arrow.classList.remove('rotate-180');
        }
      }
    };
    
    const handleKeyDown = (e: Event) => {
      const keyboardEvent = e as KeyboardEvent;
      if (keyboardEvent.key === 'Enter' || keyboardEvent.key === ' ') {
        const target = keyboardEvent.target as HTMLElement;
        if (target.hasAttribute('data-faq-question')) {
          keyboardEvent.preventDefault();
          handleToggle(e);
        }
      }
    };
    
    // Add event listeners to all FAQ question buttons
    const questionButtons = document.querySelectorAll('[data-faq-question]');
    questionButtons.forEach((button) => {
      button.addEventListener('click', handleToggle);
      button.addEventListener('keydown', handleKeyDown);
    });
    
    // Cleanup
    return () => {
      questionButtons.forEach((button) => {
        button.removeEventListener('click', handleToggle);
        button.removeEventListener('keydown', handleKeyDown);
      });
    };
  }, []);
  
  return null;
}

